export const REGEX = {
	PHONE_NUMBER: /^(?:\+?\d{1,3})?[0]?([1-9]\d{8,14})$/,
	EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};
